'use client'

import { useRouter } from 'next/navigation'

/**
 * Sprint 62 (overnight cycle-1) — extracted client subtree for the 404 page's
 * "Go back" affordance. Lives in its own file so the parent not-found.tsx can
 * remain a server component (which preserves its `export const metadata`).
 *
 * Uses `router.back()` instead of the previous `href="javascript:history.back()"`
 * link, which the project's strict CSP (`script-src 'self'`) blocks at
 * runtime. If there is no history entry to return to (e.g. the 404 was the
 * first page in the session), we fall back to the dashboard.
 */
export function NotFoundBackButton() {
  const router = useRouter()

  return (
    <button
      type="button"
      onClick={() => {
        if (typeof window !== 'undefined' && window.history.length > 1) {
          router.back()
        } else {
          router.push('/dashboard')
        }
      }}
      className="inline-flex items-center gap-1.5 rounded-xl border px-4 py-2.5 text-sm font-semibold hover:bg-muted transition-colors"
    >
      ← Go back
    </button>
  )
}
